import React from 'react';
import { MAX_SELECTIONS, useTournamentsSelections } from './TournamentsSelectionsProvider';

import './TournamentCheckbox.css';
import { classIf } from '../data/utils/classIf';

export default function TournamentCheckbox(props) {
    const tournamentsSelections = useTournamentsSelections();

    const checked = tournamentsSelections.ids.has(props.id);
    const disabled = !checked && tournamentsSelections.ids.size === MAX_SELECTIONS;

    return (
        <div className="xs-tournament-checkbox" onClick={(e) => {e.stopPropagation()}}>
            <label>
                <input type="checkbox"
                    checked={checked}
                    onChange={() => tournamentsSelections.toggleId(props.id)}
                    className={"xs-tournament-checkbox" + classIf(disabled, 'disabled')}
                />
                <span className="checkbox"></span>
            </label>
        </div>
    );
}
